import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    description: 'Title for the suppliers card in product suppliers tab',
    defaultMessage: 'Suppliers',
    id: 'Q28xNX',
  },
  subtitle: {
    description: 'Subtitle for the suppliers card in product suppliers tab',
    defaultMessage: 'Suppliers assigned to this product, along with the unit of measure, supplier SKU and cost.',
    id: 'lMmSQ3',
  },
  assignSupplierButton: {
    description: 'Button label to assign a supplier to a product in product suppliers tab',
    defaultMessage: 'Assign Supplier',
    id: 'sc2OFu',
  },
  columnSupplierName: {
    description: 'Column header for supplier name in product suppliers tab',
    defaultMessage: 'Supplier',
    id: 'G9gBTM',
  },
  columnUomSku: {
    description: 'Column header for unit of measure SKU in product suppliers tab',
    defaultMessage: 'UoM SKU',
    id: 'tWxb7p',
  },
  columnSupplierSku: {
    description: 'Column header for supplier SKU in product suppliers tab',
    defaultMessage: 'Supplier SKU',
    id: '3h0tZO',
  },
  columnCost: {
    description: 'Column header for cost in product suppliers tab',
    defaultMessage: 'Cost',
    id: 'NwXXHd',
  },
  emptyState: {
    description: 'Empty state message in product suppliers tab when no suppliers are assigned',
    defaultMessage: 'No suppliers are assigned to this product.',
    id: 'E+4+Jo',
  },
  loadingError: {
    description: 'Error message in product suppliers tab when suppliers fail to load',
    defaultMessage: 'Failed to load suppliers.',
    id: 'GzjA5H',
  },
  rowEdit: {
    description: 'Dropdown menu item label to edit a supplier row in product suppliers tab',
    defaultMessage: 'Edit',
    id: '5Zg8uU',
  },
  rowDelete: {
    description: 'Dropdown menu item label to delete a supplier row in product suppliers tab',
    defaultMessage: 'Delete',
    id: 'TSFHVh',
  },
  rowActionsMenu: {
    description: 'Aria label for the button that opens the actions menu for a supplier row in product suppliers tab',
    defaultMessage: 'Supplier actions',
    id: 'gRcxng',
  },
  deleteConfirmTitle: {
    description: 'Title of delete confirmation modal in product suppliers tab',
    defaultMessage: 'Remove supplier?',
    id: 'yT3jFP',
  },
  deleteConfirmBody: {
    description: 'Body text of delete confirmation modal in product suppliers tab',
    defaultMessage: 'Are you sure you want to remove this supplier from the product?',
    id: '4Bcz3h',
  },
  deleteConfirmAction: {
    description: 'Confirm button in delete confirmation modal in product suppliers tab',
    defaultMessage: 'Remove',
    id: 'pAeE9R',
  },
  deleteConfirmCancel: {
    description: 'Cancel button in delete confirmation modal in product suppliers tab',
    defaultMessage: 'Cancel',
    id: '8hCOc6',
  },
  deleteError: {
    description: 'Error notification when deleting a supplier association fails in product suppliers tab',
    defaultMessage: 'Failed to remove the supplier association. Please try again.',
    id: 'uJdRhl',
  },
});
